import { Link } from 'react-router-dom';
import CapePeninsulaImage from './assets/cape-peninsula.jpg';

function CapePeninsulaPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage cape-peninsula-hero">
        <div className="hero-content">
          <h1>Iconic Cape Point & Peninsula Tour</h1>
          <p>Journey along dramatic coastlines to the mythical meeting point of two oceans.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">Where Two Oceans Meet</h2>
          <div className="content-intro">
            <img src={CapePeninsulaImage} alt="Cape Point & Peninsula Tour" className="tour-main-image" />
            <p>Our signature Cape Point & Peninsula Tour with Ebamba Travel & Tours is an essential Cape Town experience. This full-day adventure takes you on a breathtaking scenic drive along the Atlantic Seaboard, past picturesque fishing villages, and through stunning nature reserves, culminating at the legendary Cape Point.</p>
            <p>Witness where the Atlantic and Indian Oceans reputedly meet, explore the Cape of Good Hope, and marvel at the adorable African Penguins at Boulders Beach. Every turn offers a new postcard-perfect view, making this tour a photographer's dream and a nature lover's paradise.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Peninsula Tour</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-car-alt"></i>
              <h4>Scenic Drives</h4>
              <p>Travel along Chapman's Peak Drive (weather permitting), one of the world's most spectacular coastal roads.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-fish"></i>
              <h4>Boulders Beach Penguins</h4>
              <p>Get up close (but not too close!) with a thriving colony of African Penguins at Boulders Beach.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-compass"></i>
              <h4>Cape Point & Cape of Good Hope</h4>
              <p>Visit the southwesternmost tip of Africa, explore the historic lighthouse, and take in the dramatic cliffs.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-water"></i>
              <h4>Coastal Villages</h4>
              <p>Pass through charming coastal towns like Hout Bay and Simon's Town, with opportunities for curio shopping or a fresh seafood lunch.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Travelers</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"The Cape Peninsula Tour with Ebamba was the highlight of our trip! Every view was stunning, and seeing the penguins was just magical. Our guide was truly exceptional."</p>
              <span>– Hannah P. from Germany</span>
            </div>
            <div className="testimonial-card">
              <p>"From Chapman's Peak to Cape Point, it was an absolutely magnificent day. Ebamba's attention to detail and personalized service made it perfect."</p>
              <span>– Liam F. from Australia</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Book Your Cape Point Adventure</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CapePeninsulaPage;
